import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa'; // Ícone do globo
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const handleChangeLanguage = (event) => {
        const selectedLanguage = event.target.value;
        i18n.changeLanguage(selectedLanguage);
    };

    return (
        <div className="language-switcher">
            <FaGlobe className="globe-icon" /> {/* Ícone do globo */}
            <select onChange={handleChangeLanguage} className="language-select" defaultValue={i18n.language}>
                <option value="en">English</option>
                <option value="pt">Português</option>
                <option value="fr">Francês</option>
                <option value="de">Alemão</option>
            </select>
        </div>
    );
};

export default LanguageSwitcher;
